import { gql } from "@apollo/client";

export const CREATE_CATEGORY = gql`
  mutation createCategory($name: String!, $franchise_id: Float!) {
    createCategory(name: $name, franchise_id: $franchise_id) {
      id
      name
    }
  }
`;

export const UPDATE_CATEGORY = gql`
  mutation updateCategory($id: Float!, $name: String!) {
    updateCategory(id: $id, name: $name) {
      id
      name
    }
  }
`;

export default CREATE_CATEGORY;
